$(document).on('submit', '.js-contact-form', function (e) {
    const $that = $(this);
    const $submitButton = $that.find("button[type='submit']");
    e.preventDefault();
    $submitButton.button('loading');

    const $form = $('.js-contact-form');
    let $formValidationReportList = $form.find('.js-validation-summary ul');
    $formValidationReportList.empty();
    $formValidationReportList.removeClass('validation-success');

    grecaptcha.ready(function () {
        // do request for recaptcha token
        const siteKey = $that.data("recaptchaSiteKey");
        grecaptcha.execute(siteKey, { action: 'contact' }).then(function (token) {
            // add token to form
            $that.find(".js-recaptcha-token").val(token);
            let data = $form.serialize();

            $.ajax({
                url: "/Contact/PostMessage",
                type: 'POST',
                data: data,
                dataType: 'json',
                success: function (data) {
                    if (data.success == true) {
                        $formValidationReportList.addClass('validation-success');
                        $formValidationReportList.append('<li>' + 'Votre message a bien été transmis. Merci !' + '</li>');
                        // Reset the form.
                        $that.get(0).reset();
                    }
                    else {
                        for (let i = 0; i < data.modelErrors.length; i++) {
                            $formValidationReportList.append('<li>' + data.modelErrors[i] + '</li>');
                        }
                    }
                    $submitButton.button('reset');
                    $formValidationReportList.focus();
                },
                error: function (data) {
                    console.log("Unexpected error occured while trying to transfer contact request.");
                    $formValidationReportList.addClass('validation-error');
                    $formValidationReportList.append("<li>Une erreur innatendue est survenue. Votre demande n'a pas été transmise. Veuillez réessayer.</li>");
                    $submitButton.button('reset');
                    $formValidationReportList.focus();
                },
            });
        });
    });

});